import script from "./VTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./VTabs.vue?vue&type=script&lang=ts&setup=true"

import "./VTabs.vue?vue&type=style&index=0&id=9b6bb51e&lang=sass"

const __exports__ = script;

export default __exports__